//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { insureApplyQuery } from '@/api/credit';
import { notReson } from '@/api/apis';
export default {
  name: 'InsureApplyQuery',
  filters: {
    protoStatus: function protoStatus(value) {
      if (value == '1') return '暂存';else if (value == '2') return '修改中';else if (value == '3') return '已提交';else if (value == '4') return '保险公司未承保';else if (value == '5') return '保单生效';
    }
  },
  data: function data() {
    return {
      showFlag: false,
      loading: true,
      restaurants: [],
      timeout: null,
      tableData: {
        content: [],
        pageNum: 0,
        pageSize: 0,
        pages: 0,
        startRow: 0,
        totalCount: 0
      },
      permissionsbtn: true,
      value: '',
      applicationStatusList: [{
        codeCode: '',
        codeName: '全部'
      }, {
        codeCode: '2',
        codeName: '修改中'
      }, {
        codeCode: '3',
        codeName: '已提交'
      }, {
        codeCode: '4',
        codeName: '保险公司未承保'
      }, {
        codeCode: '5',
        codeName: '保单生效'
      }],
      inForm: {
        pageNo: 1,
        pageSize: 10,
        applicationNo: '',
        applicantName: '',
        applicationStatus: '',
        expectStartDate: '',
        expectEndDate: '',
        submitStartDate: '',
        submitEndDate: '',
        policyNo: ''
      },
      formData: {
        notUnderWriteReason: '',
        //保单不承保原因
        applicationNo: '' //投保申请单号

      },
      formDataRules: {
        notUnderWriteReason: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }]
      },
      underWriteTittle: '',
      pageNo: 1,
      // 第几页
      pageSize: 10,
      // 每页数量
      total: 0,
      // 总条数
      options_insuranceCompanyName: [],
      options_companyName: []
    };
  },
  watch: {
    '$route': 'getPath' // 当路由发生变化时执行此函数

  },
  mounted: function mounted() {},
  created: function created() {
    this.Init_get();
  },
  methods: {
    submit: function submit(type, data) {
      console.log(type);
      console.log(data);
      console.log('userType是否为02', data.row.userType);
      var userType = data.row.userType;

      if (type == 'view') {
        this.$router.push({
          path: "/creditInsure/seePromisePolicy/".concat(type, "/").concat(data.row.applicationNo, "/").concat(userType)
        });
      } else if (type == 'edit') {
        this.$router.push({
          path: "/creditInsure/promisePolicy/".concat(type, "/").concat(data.row.applicationNo, "/").concat(userType)
        });
      }
    },
    underWrite: function underWrite(type, data) {
      this.showFlag = true;
      this.formData.applicationNo = data.applicationNo;
      console.log('保单号', data.applicationNo);
    },
    view: function view(type, data) {
      console.log('data', data);
      this.$router.push({
        path: "/creditInsure/inputPolicy/".concat(type, "/").concat(data.applicationNo)
      });
    },
    cancel: function cancel() {
      console.log("取消");
      this.showFlag = false;
      this.$refs['formData'].resetFields();
    },
    confirm: function confirm() {
      var _this = this;

      console.log('点击确定');
      this.$refs['formData'].validate(function (valid) {
        console.log('valid==', valid);

        if (valid) {
          notReson(_this.formData).then(function (res) {
            if (res.rtnCode == '0000') {
              console.log('返回的res', res);

              _this.$message({
                type: 'success',
                message: '提交成功'
              });

              _this.showFlag = false;

              _this.$refs['formData'].resetFields();

              _this.Init_get();
            }
          }).catch(function (error) {
            _this.showFlag = false;
            console.log(error);
          });
        }
      });
    },
    getPath: function getPath() {
      this.Init_get();
    },
    // 初始化
    Init_get: function Init_get() {
      var _this2 = this;

      var params = this.inForm;
      this.loading = true;
      params.pageNo = this.pageNo;
      params.pageSize = this.pageSize;
      insureApplyQuery(params).then(function (res) {
        _this2.tableData = res;
        _this2.loading = false;
      });
    },
    // 每页条数
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.Init_get();
    },
    // 当前页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.Init_get();
    },
    // 查询
    search_s: function search_s(formName) {
      var _this3 = this;

      var data = {};

      if (this.inForm.submitStartDate && this.inForm.submitEndDate) {
        if (this.inForm.submitStartDate > this.inForm.submitEndDate) {
          this.$message({
            type: 'warning',
            message: '申请提交日期起不能晚于申请提交日期止'
          });
          return false;
        }
      } //  去除首尾空格


      if (this.inForm.expectStartDate && this.inForm.expectEndDate) {
        if (this.inForm.expectStartDate > this.inForm.expectEndDate) {
          this.$message({
            type: 'warning',
            message: '起保起期不能晚于起保止期'
          });
          return false;
        }
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.pageNo = 1;

          _this3.Init_get();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置
    search_s_clear: function search_s_clear() {
      this.inForm = {
        pageNo: 1,
        pageSize: 10,
        applicationNo: '',
        applicantName: '',
        applicationStatus: '',
        expectStartDate: '',
        expectEndDate: '',
        submitStartDate: '',
        submitEndDate: '',
        policyNo: ''
      };
    },
    // 删除
    del_but: function del_but(row) {
      var _this4 = this;

      this.$confirm('此操作将永久删除该申请单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = {
          applicationNo: row.row.applicationNo
        };
        deleteByProposalNo_fun(data).then(function (res) {
          if (res.rtnCode == '0000') {
            _this4.$message({
              message: '删除成功',
              type: 'success'
            });

            _this4.Init_get();
          }
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      console.log(row); //				this.tableData.splice(row.$index, 1)
    },
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter: function createStateFilter(queryString) {
      return function (state) {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect: function handleSelect(item) {
      console.log(item);
    }
  }
};